import React, { useEffect } from 'react';
import './i18n';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import useUtmStore from './store/useUtmStore';
import HomePage from './components/homepage/HomePage';
import InvoicegstPage from './components/invoicegst/InvoicegstPage';
import PaymentPage from './components/payment/PaymentPage';
import CommercialVehiclePage from './components/commercialVechiclePage/CommercialVehiclePage';
import InventoryFinancingPage from './components/inventoryFinancingPage/InventoryFinancingPage';
import BusinessExpansionPage from './components/businessExpansionPage/BusinessExpansionPage';
import LenderPage from './components/lenderPage/LenderPage';
import Bizzie from './bizzie/Bizzie';
import BizzieLoanRequest from './components/bizzieChat/BizzieLoanRequest';
import GrievanceRedressalPage from './components/grievanceMechanismPage/GrievanceRedressalPage';
import { ASSETS_URL } from './constants';
import PrivacyPolicyPage from './components/privacyPolicy/PrivacyPolicyPage';
import BusinessListingPage from './components/BusinessListing/BusinessListingPage';
import BusinessListingProductDetails from './components/businessListingProductDetails/businessListingProductDetails';
// import BusinessOnboardingAll from './components/businessOnboarding/businessOnboardingAll';
// import BusinessListingLandingPage from './components/businessListingLanding/BusinessListingLandingPage';
import WordPressContentPage from './components/WordPressContent/WordPressContentPage';
import WordPressIframePage from './components/WordPressContent/WordPressIframePage';
import ScrollToTop from './utility/ScrollToTop';
import InventoryFinancingApplicationPage from './components/inventoryFinancingPage/InventoryFinancingApplicationPage';
import AnchorLandingPage from './components/anchorPage/AnchorLandingPage';
import EmiCalculatorPage from './components/emiCalculator/EmiCalculatorPage';
import CustomerDashboard from './components/dashboard/CustomerDashboard';
import { setupAxiosInterceptor } from './services/axiosInterceptor';

function App() {
  useEffect(()=>{
    document.documentElement.style.setProperty('--assets-url', ASSETS_URL); 
    console.log(document.documentElement.style.getPropertyValue('--assests-url'))
    
    // Setup axios interceptor for automatic token refresh on 401 errors
    setupAxiosInterceptor();
  },[]);

  return (
    <Router>
      <ScrollToTop />
      <NavigationRestorer />
      <Routes>
        {/* Define your routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/invoice-gst" element={<InvoicegstPage />} />
        <Route path="/payments" element={<PaymentPage/>}/>
        <Route path="/commercial-vehicle-loan" element={<CommercialVehiclePage/>} />
        <Route path="/inventory-financing" element={<InventoryFinancingPage/>}/>
        <Route path="/inventory-financing/application" element={<InventoryFinancingApplicationPage/>}/>
        <Route path="/business-expansion" element={<BusinessExpansionPage/>}/>
        <Route path="/bizzie" element={<Bizzie/>}/>
        {/* <Route path="/bizzie/:loanRequestId" element={<BizzieLoanRequest/>}/> */}
        <Route path="/dashboard" element={<CustomerDashboard/>}/>
        <Route path="/lending-partners" element={<LenderPage/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        {/* <Route path="/grievance-redressal-page" element={<GrievanceRedressalPage />} /> */}
        <Route path="/business-listing" element={<BusinessListingPage />} /> 
        <Route path="/business-details/:businessName" element={<BusinessListingProductDetails />} />
        {/* <Route path="/business-listing-landing" element={<BusinessListingLandingPage />} />  */}
        {/* <Route path="/list-your-business" element={<BusinessOnboardingAll />} /> */}
        <Route path="/supply-chain-financing/anchor-registration" element={<AnchorLandingPage />} />
        <Route path="/emi-calculator" element={<EmiCalculatorPage />} />
        {/* <Route path="/how-to" element={<WordPressIframePage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;

// Component to handle navigation restoration and capture UTM params

const NavigationRestorer = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const setUtmData = useUtmStore(state => state.setUtmData);

  const resetUtm = useUtmStore(state => state.resetUtm);

  const utm = useUtmStore(state => state.utm);

  const utmPersisted = useUtmStore(state => state.utmPersisted);

  useEffect(() => {

    // Clear any old stored page info when app loads
    // We want users to naturally land on homepage when returning from lender pages
    const storedPageInfo = localStorage.getItem('growbizh_previous_page');
    if (storedPageInfo) {
      try {
        const pageInfo = JSON.parse(storedPageInfo);
        const timeDiff = Date.now() - pageInfo.timestamp;
        
        // Clear stored info if it's old (more than 1 hour)
        if (timeDiff >= 3600000) {
          localStorage.removeItem('growbizh_previous_page');
        }
      } catch (error) {
        console.error('Error parsing stored page info:', error);
        localStorage.removeItem('growbizh_previous_page');
      }
    }

    // Only initialize UTM capture/reset on the first app load in this browser tab/session.
    // We use sessionStorage to detect first-run per tab so internal SPA navigation doesn't reset state.
    try {
      // Build a lowercase-key map of params so incoming param *names* are treated case-insensitively.
      const rawParams = new URLSearchParams(location.search);
      const lowerParams = new Map();
      for (const [k, v] of rawParams.entries()) {
        lowerParams.set(k.toLowerCase(), v);
      }

      // Accept either camelCase, snake_case or any case variations by reading lowercase keys.
      const utmSourceRaw = lowerParams.get('utmsource') || '';
      const utmMediumRaw = lowerParams.get('utmmedium') || '';
      const utmCampaignRaw = lowerParams.get('utmcampaign') || '';

      const utmSource = utmSourceRaw ? utmSourceRaw.toUpperCase() : '';
      const utmMedium = utmMediumRaw ? utmMediumRaw.toUpperCase() : '';
      const utmCampaign = utmCampaignRaw ? utmCampaignRaw.toUpperCase() : '';
      const hasParams = !!(utmSource || utmMedium || utmCampaign);

      const initialized = sessionStorage.getItem('snapfunds_utm_initialized');
      // If session already initialized with utm, nothing to do.
      if (initialized === 'with_utm' && !hasParams) return;
      // If session was initialized without utm and there are no params now, nothing to do.
      if (initialized === 'without_utm' && !hasParams) return;

      if (hasParams) {
        const utmPayload = {};
        if (utmSource) utmPayload.utmSource = utmSource;
        if (utmMedium) utmPayload.utmMedium = utmMedium;
        if (utmCampaign) utmPayload.utmCampaign = utmCampaign;
        setUtmData(utmPayload);
        // mark session as initialized with utm so we persist/append across navigation
        sessionStorage.setItem('snapfunds_utm_initialized', 'with_utm');
        try { console.debug('UTM captured:', utmPayload); } catch (e) {}
      } else {
        // No relevant UTM on initial load — clear any previously persisted UTM so stale values are not reused.
        resetUtm();
        sessionStorage.setItem('snapfunds_utm_initialized', 'without_utm');
      }
    } catch (err) {
      // ignore malformed URLs and sessionStorage errors
    }
  }, [navigate, location.pathname, location.search, setUtmData, resetUtm]);

  // If UTM has been captured previously (utmPersisted) then ensure internal navigation URLs
  // display the utm params so they follow the user across pages. We append params only
  // when they are not already present in the current URL.
  useEffect(() => {
    try {
      if (!utmPersisted) return;

      // Treat URL param *names* case-insensitively when checking presence.
      const currentRawParams = new URLSearchParams(location.search);
      const currentLowerParams = new Map();
      for (const [k, v] of currentRawParams.entries()) {
        currentLowerParams.set(k.toLowerCase(), v);
      }
      const hasUtmInUrl = currentLowerParams.has('utmsource') && currentLowerParams.has('utmmedium') && currentLowerParams.has('utmcampaign');

      if (!hasUtmInUrl) {
        const newParams = new URLSearchParams(location.search);
        // set both snake_case (marketing standard) and camelCase (internal) keys so downstream code picks them up
        if (utm?.utmSource) {
          newParams.set('utmSource', utm.utmSource);
        }
        if (utm?.utmMedium) {
          newParams.set('utmMedium', utm.utmMedium);
        }
        if (utm?.utmCampaign) {
          newParams.set('utmCampaign', utm.utmCampaign);
        }
        const newQuery = newParams.toString();
        const newUrl = location.pathname + (newQuery ? `?${newQuery}` : '') + (location.hash || '');
        // replaceState avoids adding history entries and avoids full navigation
        window.history.replaceState(null, '', newUrl);
      }
    } catch (err) {
      // ignore
    }
  }, [location.pathname, location.search, utmPersisted, utm]);

  return null;
};